import React, { useState } from "react";
import PropTypes from "prop-types";

import { Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import atsColorPicker from "../../global/utility/atsColorPicker";
import { useNavigate } from "react-router-dom";
import EditDevice from "./EditDevice";


function SingleDeviceHeader(props) {
  const { isBLE, isMap, location } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const deviceData = useSelector((state) => state.singleDeviceHeader.data);
 
  const navigate = useNavigate();
  const closeModal = () => {
    setIsModalVisible(false);
  };
  const openSingleModal = (id) => {
    setIsModalVisible(true);
  };
  const openAlerts = (id) => {
    navigate(`/Alerts`, {
      state: {deviceId:deviceData&&deviceData[0]?.name, deviceName:deviceData&&deviceData[0]?.name},
    });
  };
  return (
    <div className="view-device-dashboard-header">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <small
            className="text-muted"
            style={{ fontSize: "48px", paddingRight: "10px" }}
          >
            {isBLE && <i className="bi-bluetooth"></i>}
            {!isBLE && <i className="bi-router"></i>}
          </small>
          <span
            style={{
              fontFamily: "VerizonNHGDS",
              fontSize: "48px",
              fontWeight: 300,
            }}
          >
            {deviceData[0]?.name}
          </span>
        </div>
        {isMap && (
          <div className="d-flex justify-content-end align-items-center">
            <Dropdown
              menu={{
                items: [
                  {
                    label: (
                      <div>
                        <span className="font-face-vzw">
                          LINKS
                        </span>
                      </div>
                    ),
                    key: "0",
                  },
                  {
                    label: (
                      <div
                      className="dropdown-item hover-div"
                        onClick={() => openAlerts(location?.state?.name)}
                      >
                        View Alerts
                      </div>
                    ),
                    key: "1",
                  },
                  {
                    type: "divider",
                    key: "3",
                  },
                  {
                    label: (
                      <div>
                        <span className="font-face-vzw">
                          ACTIONS
                        </span>
                      </div>
                    ),
                    key: "4",
                  },
                  {
                    label: (
                      <div
                        className="dropdown-item hover-div"
                        data-turbo-frame="_top"
                        role="button"
                        href="javascript:void(0);"
                        onClick={() => openSingleModal(deviceData)}
                      >
                        Edit Device
                      </div>
                    ),
                    key: "5",
                  },
                ],
              }}
              trigger={["click"]}
              overlayClassName="more-links-overlay"
            >
              <div className="more-links">
                <MoreOutlined />
              </div>
            </Dropdown>
          </div>
        )}
      </div>
      {isModalVisible && (
        <EditDevice
          visible={isModalVisible}
          onClose={closeModal}
          onSave={closeModal}
          onEditDeviceUpdate={() => {
            setIsModalVisible(false);
          }}
          selectedDevice={location?.state}
        />
      )}
      <div
        style={{
          display: "flex",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        <div
          className="m-1 font-face-vzw alarm-condition"
          style={{
            backgroundColor: atsColorPicker(deviceData[0]?.healthStatus)?.bg,
            color: atsColorPicker(deviceData[0]?.healthStatus)?.text,
          }}
        >
          {deviceData[0]?.healthStatus?.toUpperCase() || "UNKNOWN"}
        </div>
        <div
          className="m-1 font-face-vzw alarm-condition"
          style={{
            backgroundColor: atsColorPicker(deviceData[0]?.connectionStatus)
              ?.bg,
            color: atsColorPicker(deviceData[0]?.connectionStatus)?.text,
          }}
        >
          {deviceData[0]?.connectionStatus?.toUpperCase() || "UNKNOWN"}
        </div>
        {/* <div
          className="m-1 font-face-vzw alarm-condition"
          style={{
            backgroundColor: atsColorPicker(deviceData[0]?.assetStatus)?.bg,
            color: atsColorPicker(deviceData[0]?.assetStatus)?.text,
          }}
        >
          {deviceData[0]?.assetStatus?.toUpperCase() || "UNKNOWN"}
        </div>
        <div
          className="m-1 font-face-vzw alarm-condition"
          style={{
            backgroundColor: atsColorPicker(deviceData[0]?.activeStatus)?.bg,
            color: atsColorPicker(deviceData[0]?.activeStatus)?.text,
          }}
        >
          {deviceData[0]?.activeStatus?.toUpperCase() || "UNKNOWN"}
        </div> */}
        {/*<div className="m-1">
          <span className="font-face-vzw">Organization:</span>&nbsp;
          <Link to={"/organization"} state={{ search: [deviceData[0]?.organizationName] }} className="link-alarms">
            {deviceData[0]?.organizationName}
          </Link>
        </div>
        <div className="my-1 mx-3">
          <span className="font-face-vzw">Location:</span>&nbsp;
          <Link to={"/locationdetails"} state={{ search: [deviceData[0]?.locationName] }} className="link-alarms">
            {deviceData[0]?.locationName}
          </Link>
        </div>*/}
      </div>
    </div>
  );
}

SingleDeviceHeader.propTypes = {
  isBLE: PropTypes.bool.isRequired,
  isMap: PropTypes.bool.isRequired,
};

export default SingleDeviceHeader;
